// removed by extract-text-webpack-plugin
module.exports = {"Base":"RecentNews__Base-1HI9h","Header":"RecentNews__Header-1hhVw","Link":"RecentNews__Link-37k-x"};


/*****************
 ** WEBPACK FOOTER
 ** ./src/components/RecentNews/RecentNews.css
 ** module id = 639
 ** module chunks = 0
 **/